import React from 'react'


function Credits({ content }) {

    return (
        <div>
            <h2>credits</h2>
            <h4>this website made possible by:</h4> 
            <small>
           
                   <p>react95 - <a href='https://github.com/React95/React95' target='_blank' rel="noopener noreferrer">https://github.com/React95/React95</a></p>
                  
                   <p>webamp - <a href='https://github.com/captbaritone/webamp' target='_blank' rel="noopener noreferrer">https://github.com/captbaritone/webamp</a></p>

                   <p>jspaint - <a href='https://github.com/1j01/jspaint' target='_blank' rel="noopener noreferrer">https://github.com/1j01/jspaint</a></p>
                 
                   <p>mines - <a href='https://github.com/oL-web/react-minesweeper' target='_blank' rel="noopener noreferrer">https://github.com/oL-web/react-minesweeper</a></p>
                     
                   <p>synth - <a href='https://github.com/kevinsqi/react-piano' target='_blank' rel="noopener noreferrer">https://github.com/kevinsqi/react-piano</a></p>
                   <p><a href='https://github.com/JackZYang/react-synthesizer' target='_blank' rel="noopener noreferrer">https://github.com/JackZYang/react-synthesizer</a></p> 

                   <p>floppy box - <a href='https://github.com/Hitman666/FlappyBox' target='_blank' rel="noopener noreferrer">https://github.com/Hitman666/FlappyBox</a></p>               
           
                   <p>space invaders - <a href=' https://github.com/dwmkerr/spaceinvaders' target='_blank' rel="noopener noreferrer"> https://github.com/dwmkerr/spaceinvaders</a></p>               

                  
                  </small>
          
               
              <br/>
              <br/>


        </div>

        
    )
}

export default Credits
